import { useSessionStorage } from '@kk/shared/hooks/useSessionStorage';
import { BaseButton } from '@kk/ui/components/Button';
import Icon from '@kk/ui/components/Icon';
import { useTranslation } from 'react-i18next';

export type SystemNoticeProps = {
  title: string;
  message: string;
  closeable: boolean;
  onDismiss?: () => void;
};

export function SystemNotice({
  title,
  message,
  closeable,
  onDismiss,
}: SystemNoticeProps) {
  const { t } = useTranslation();
  // shortcut: Replace this static draft key with API notice identity when the backend lands.
  const [noticeState, setNoticeState] = useSessionStorage(
    'system-notice-dismissed',
    { dismissed: false },
  );

  if (closeable && noticeState.dismissed) return null;

  return (
    <aside
      role="alert"
      className="flex w-full items-center justify-between gap-4 bg-orange-60 px-6 py-4 text-neutral-200"
    >
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <h2 className="typ-body-bold leading-3">{title}</h2>
        <p className="typ-body-xs">{message}</p>
      </div>
      {closeable ? (
        <BaseButton
          type="button"
          aria-label={t('closeMenu')}
          className="focus-visible:ring-2 focus-visible:ring-blue-60 focus-visible:ring-offset-2 flex size-10 shrink-0 items-center justify-center rounded bg-transparent p-2 hover:bg-black/10 active:bg-black/20"
          onClick={() => {
            setNoticeState({ dismissed: true });
            onDismiss?.();
          }}
        >
          <Icon
            type="cross"
            size="small"
            className="size-6"
            aria-hidden="true"
            focusable="false"
          />
        </BaseButton>
      ) : null}
    </aside>
  );
}
